import { GENERATION_SOURCE_TYPE } from 'src/data/generation';
import {
  doesToolSupportEnhancedImprovements,
  GENERATION_TOOL,
  getToolDescription,
  getToolGeneratingLoaderText,
  getToolTitle,
  isContentImproverTool,
  isFreestyleGenerationTool,
} from 'src/data/generationTool';

const formatLoaderTitle = ({
  sourceType,
  generationTool,
  originalVariationId,
  manualInstructions,
}) => {
  let title = 'Generating';
  let isUseDescription = true;
  let tail = null;

  if (isImproveScore({ generationTool, originalVariationId, manualInstructions })) {
    title = 'Boosting';
    tail = 'Performance';
  } else if (sourceType === GENERATION_SOURCE_TYPE.improveListScore) {
    title = 'Improving score';
  } else if (generationTool === GENERATION_TOOL.summarizer) {
    title = 'Summarizing';
    isUseDescription = false;
  } else if (isContentImproverTool(generationTool)) {
    title = 'Improving content';
    isUseDescription = false;
  }

  return {
    title,
    isUseDescription,
    tail,
  };
};

const formatToolTitle = ({ generationTool, title, description, skipGetTextByTool }) => {
  const toolTitle = title || getToolTitle(generationTool);
  const toolDescription = description || getToolDescription(generationTool);

  if (isFreestyleGenerationTool(generationTool)) {
    return ``;
  }

  const loaderText = skipGetTextByTool ? '' : getToolGeneratingLoaderText(generationTool);

  if (loaderText) {
    return loaderText;
  }

  return `${toolTitle}${toolDescription ? ` - ${toolDescription}` : ''}`;
};

const isImproveScore = ({ generationTool, originalVariationId, manualInstructions }) => {
  if (!doesToolSupportEnhancedImprovements(generationTool)) {
    return false;
  }

  if (!originalVariationId) {
    return false;
  }

  return !manualInstructions;
};

export const getGenerationLoaderContent = (params) => {
  const { title, isUseDescription, tail } = formatLoaderTitle(params);
  const description = isUseDescription ? formatToolTitle(params) : null;

  return {
    title,
    description,
    tail,
  };
};
